import {
    IDataArray,
    DataArray,
    Company,
    Minesite,
    Permission,
	SectionPermission,
	UserCompany
} from './../../shared/index';

import { parseUtcAsLocal } from "app/shared/utils/date-utils";

export class User implements IDataArray {
    public Id = 0;
    public FirstName: string;
    public LastName: string;
    public UserName: string;
    public Active: boolean;
    public RegistrationDate: Date;
    public PermissionId: number;
    public CreatedBy: string;
    public LastLogin: Date;
    public Archived: boolean;
    public CompanyId: number = null;
    public MinesiteId: number = null;
    public StartPage: string;
    public LanguageName: string;
    public AllowPrinting = false;
    public ResetPassword: boolean;
    public ResetSecurityQuestions: boolean;

    public SectionPermissions: Object[];

    public Company: Company = null;
    public Minesite: Minesite = null;
    public Permission: Permission = new Permission();
	public Sections: DataArray<SectionPermission> = new DataArray<SectionPermission>();
	public AssignedCompanies: Company[] = [];
    public Companies: UserCompany[] = [];

    public Selected = false;

    get Registered(): string {
        return this.RegistrationDate ? (this.RegistrationDate.toLocaleDateString() +  ' ' +this.RegistrationDate.toLocaleTimeString()) : '';
    }

	public IsSpecial(): boolean {
		return this.AssignedCompanies.length !== 0;
	}

    public GetById(): number {
        return this.Id;
    }

    constructor(data?: Partial<User>) {
    Object.assign(this, data);
    if (data?.RegistrationDate) {
      this.RegistrationDate = parseUtcAsLocal(data.RegistrationDate);
    }
  }
}
